export default "__VITE_ASSET__BgnVGrQB__"